// extracted by mini-css-extract-plugin
export var addButton = "_fq-0";
export var border = "_fq-8";
export var check = "_fq-h";
export var danger = "_fq-6";
export var dropdownContainer = "_fq-1";
export var editModalBody = "_fq-j";
export var footerContainer = "_fq-i";
export var fullWidth = "_fq-a";
export var hide = "_fq-9";
export var icon = "_fq-3";
export var input = "_fq-7";
export var inputFlex = "_fq-b";
export var inputWrapper = "_fq-c";
export var manualFocus = "_fq-5";
export var optionButton = "_fq-4";
export var pillWrapper = "_fq-e";
export var pointer = "_fq-2";
export var showOverflow = "_fq-f";
export var tagsFlex = "_fq-d";
export var xButton = "_fq-g";